import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { useCallback } from "react";
import { useTheme } from "styled-components";
import { genKey } from "../../../../../../helpers/keys.js";
import { tabIcon } from "../../constants/index.js";
import * as S from "../../styled.js";
export const TabButtonView = ({ tab , className , selectedTab , onClick , disabled =false , orientation ='horizontal'  })=>{
    const handleOnClick = useCallback(()=>{
        if (disabled) return;
        const tabIndex = tab?.index ?? 0;
        onClick(tabIndex);
    }, [
        onClick,
        tab.index,
        disabled
    ]);
    const isActive = selectedTab === tab.index;
    const { id  } = useTheme();
    const icon = tabIcon(id);
    return /*#__PURE__*/ _jsxs(S.TabsButton, {
        className: classNames({
            'is-active': isActive,
            [`${className}-button`]: !!className
        }),
        onClick: handleOnClick,
        type: "button",
        tabIndex: isActive ? 0 : -1,
        id: `${className}-btn-${tab.index}`,
        $orientation: orientation,
        role: "tab",
        children: [
            tab.label,
            orientation === 'vertical' && !isActive && /*#__PURE__*/ _jsx(S.TabsVerticalIcon, {
                className: icon
            })
        ]
    }, genKey(`${className}-btn-${tab.index}`));
};
export default TabButtonView;

//# sourceMappingURL=index.js.map